export const WEB_COMPONENT_ACTIONS = {
  SET_DATA: '@/WEB_COMPONENT/SET_DATA',
  LOGIN_REQUIRED_MODAL: '@/WEB_COMPONENT/LOGIN_REQUIRED_MODAL',
  SAVE_PROJECT_MODAL: '@/WEB_COMPONENT/SAVE_PROJECT_MODAL',
  ADD_TO_CART_STATUS: '@/WEB_COMPONENT/ADD_TO_CART_STATUS',
  SHORTCUT_MODAL: '@/WEB_COMPONENT/SHORTCUT_MODAL',
};

// The PxC portal host (formerly the `DOMAIN[APP_BUILD]` enum) and the customer-support link are
// now runtime configuration: read them via `getConfig()` from `@/config/runtimeConfig`
// (`pxcPortalUrl` / `customerSupportUrl`) instead of importing constants here.
